import { useQuery } from '@tanstack/react-query'
import { getProductSalesSeries, type SalesSeriesParams, type SalesPoint } from '@/lib/api/performance'

const STALE = 30 * 60_000

export function useSalesSeries(productId: string | undefined, params: SalesSeriesParams, enabled = true) {
  return useQuery<SalesPoint[]>({
    queryKey: ['sales-series', productId, params.from, params.to, params.channelId],
    queryFn: () => getProductSalesSeries(productId as string, params),
    enabled: enabled && !!productId,
    staleTime: STALE,
  })
}
